import React, { useMemo } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { useTheme } from "../../context/ThemeContext";

/**
 * Full-bleed editorial wizard chrome. Children are arranged top-to-bottom:
 *   <NtOnboardingTopRail />
 *   <NtOnboardingStepper />
 *   <ScrollView with header + step body />   ← provided via `body` prop
 *   <NtOnboardingFooter />
 *
 * The middle slot (`body`) is the only scrollable region; everything else
 * stays pinned.
 */
function NtOnboardingLayout({ top, body, footer }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <View style={styles.page}>
      <View style={styles.top}>{top}</View>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {body}
      </ScrollView>
      <View style={styles.foot}>{footer}</View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    page: {
      flex: 1,
      backgroundColor: t.bg,
      minHeight: "100%",
    },
    top: { flexShrink: 0 },
    scroll: { flex: 1 },
    scrollContent: {
      paddingHorizontal: 56,
      paddingTop: 48,
      paddingBottom: 32,
      maxWidth: 1100,
      width: "100%",
      alignSelf: "center",
    },
    foot: { flexShrink: 0 },
  });

export default NtOnboardingLayout;
